import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type Drawer from './drawer.vue'
import type { ButtonProps } from '@ll-plus/components'

export const footerShadowPlacement = ['inner', 'outer'] as const

export const newDrawerProps = buildProps({
  /**
   * @description 对话框外层容器的类名
   */
  rootClassName: {
    type: String,
    default: '',
  },
  /**
   * @description 抽屉是否可见
   */
  open: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 标题
   */
  title: {
    type: String,
    default: '新增',
  },
  /**
   * @description  确认/知道了按钮loading
   */
  confirmLoading: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 取消按钮的配置信息
   */
  cancelButtonProps: {
    type: definePropType<ButtonProps>(Object),
  },
  /**
   * @description 确认按钮的配置信息
   */
  okButtonProps: {
    type: definePropType<ButtonProps>(Object),
  },
  /**
   * @description 确认按钮文字
   */
  confirmText: {
    type: String,
    default: '确认',
  },
  /**
   * @description 取消按钮文字
   */
  cancelText: {
    type: String,
    default: '取消',
  },
  /**
   * @description 显示底部
   */
  showFooter: {
    type: Boolean,
    default: true,
  },
  /**
   * @description 滚动是否显示底部阴影
   */
  isShowFooterShadow: {
    type: Boolean,
    default: true,
  },
  /**
   * @description 决定底部阴影的方向(外部和内部）,默认由内容区域来决定
   */
  footerShadowPlacement: {
    type: String,
    values: footerShadowPlacement,
    default: 'inner',
  },
  /**
   * @description 是否使用esc关闭
   */
  keyboard: {
    type: Boolean,
    default: true,
  },
} as const)

export const newDrawerEmits = {
  /**
   * @description 点击取消时触发
   */
  cancel: () => true,
  /**
   * @description 点击确认时触发
   */
  confirm: () => true,
  /**
   * @description 抽屉关闭时触发
   */
  close: () => true,
  'update:open': () => true,
} as const

// props
export type NewDrawerProps = ExtractPropTypes<typeof newDrawerProps>
export type FooterShadowPlacementType = NewDrawerProps['footerShadowPlacement']

// emits
export type NewDrawerEmits = typeof newDrawerEmits

// instance
export type NewDrawerInstance = InstanceType<typeof Drawer>
